import { AutomationTaskInput } from 'generated-graphql/types';
import { findDuplicatedAutomationTasks } from './findDuplicatedAutomationTasks';
import { validateAnalysisAutomationTask } from './validateAnalysisAutomationTask';
import { normalizeBetweenScoreConditions } from './normalizeBetweenScoreConditions';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

export const validateAnalysisAutomationTasks = (
  tasks: AutomationFormItem[],
  campaignIdCanBeEmpty = false
) => {
  const normalizedTasks = normalizeBetweenScoreConditions(tasks);

  // TODO: Remove this check as it is validated via forms
  const validAutomationTasks = normalizedTasks.filter((automationTask) =>
    validateAnalysisAutomationTask(automationTask, campaignIdCanBeEmpty)
  ) as AutomationTaskInput[];

  const duplicates = findDuplicatedAutomationTasks(validAutomationTasks);

  return {
    isDuplicates: duplicates.length > 0,
    isAllTasksValid: validAutomationTasks.length === normalizedTasks.length,
    validAutomationTasks
  };
};
